import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { ListFilter } from "lucide-react";

import messages from "../../../assets/locale/messages";
import "./FilterLabel.scss";
import { UIButton } from "../../ui";

const FilterLabel = ({ onClick }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { shared } = messages[lang];
  return (
    <div className="filter-toggle-btn text-end">
      <UIButton
        onClick={onClick}
        variant="primary"
        appearance="outline"
        size="large"
        startIcon={<ListFilter size={16} aria-hidden="true" />}
      >
        {shared.filter}
      </UIButton>
    </div>
  );
};

FilterLabel.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default FilterLabel;
